'use client';

import {BadgeCheck, Bell, ChevronsUpDown, CreditCard, LogOut, Sparkles} from 'lucide-react';

import {Avatar, AvatarFallback, AvatarImage} from '@/shadcn_components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/shadcn_components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/shadcn_components/ui/sidebar';
import {useLogout} from '@refinedev/core';
import useLoginStore from '@/store/useLoginStore';
import {useMemo} from 'react';
import {Link} from 'react-router-dom';
import {Button} from '@/shadcn_components/ui/button';

export function NavUserInSidebar() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <NavUser />
      </SidebarMenuItem>
    </SidebarMenu>
  );
}

export type NavUserProps = {
  iconOnly?: boolean;
};

export function NavUser(props: NavUserProps) {
  const {iconOnly} = props;
  const {isMobile} = useSidebar();
  const {mutate: logout} = useLogout();
  const {userdata} = useLoginStore();
  const staff = userdata?.staff;
  const avatar = staff?.avatar?.thumbnail_small || staff?.avatar?.url || '';
  const subtitle = staff?.notes || '';

  async function onClickLogout() {
    await logout();
  }

  if (!userdata) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {iconOnly ? (
          <Button
            asChild
            variant="ghost"
            size="icon"
            className="cursor-pointer data-[state=open]:bg-border data-[state=open]:text-secondary-foreground data-[state=open]:border-2">
            <Avatar className="h-10 w-10 rounded-lg">
              <AvatarImage src={avatar} alt={userdata.name} className="object-cover" />
              <AvatarFallback className="rounded-lg">CN</AvatarFallback>
            </Avatar>
          </Button>
        ) : (
          <SidebarMenuButton
            size="lg"
            className="data-[state=open]:bg-border data-[state=open]:text-secondary-foreground data-[state=open]:border-2">
            <Avatar className="h-8 w-8 rounded-lg">
              <AvatarImage src={avatar} alt={userdata.name} className="object-cover" />
              <AvatarFallback className="rounded-lg text-foreground">CN</AvatarFallback>
            </Avatar>
            {!iconOnly && (
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">{userdata.name}</span>
                <span className="truncate text-xs">{subtitle}</span>
              </div>
            )}
            <ChevronsUpDown className="ml-auto size-4" />
          </SidebarMenuButton>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
        side={isMobile ? 'bottom' : 'right'}
        align="end"
        sideOffset={4}>
        <DropdownMenuLabel className="p-0 font-normal">
          <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
            <Avatar className="h-8 w-8 rounded-lg">
              <AvatarImage src={avatar} alt={userdata.name} className="object-cover" />
              <AvatarFallback className="rounded-lg">CN</AvatarFallback>
            </Avatar>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-semibold">{userdata.name}</span>
              <span className="truncate text-xs">{subtitle}</span>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <Link to="/profile">
            <DropdownMenuItem className="cursor-pointer">
              <BadgeCheck />
              Tài khoản
            </DropdownMenuItem>
          </Link>
          {/* <DropdownMenuItem className="cursor-pointer">
            <Bell />
            Thông báo
          </DropdownMenuItem> */}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem className="cursor-pointer" onClick={onClickLogout}>
          <LogOut />
          Đăng xuất
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
